export default "__VITE_ASSET__DeE3J8kn__"